import { useDataGridSort } from '@/components/tables/DataTable/hooks/useDataGridSort';
import {
  HouseholdOrder,
  HouseholdOrderField,
  OrderDirection,
} from '@/types/schema';

// Map column field names to HouseholdOrderField enum values
export const columnFieldToSortField: Record<string, HouseholdOrderField> = {
  displayName: HouseholdOrderField.SortableLastName, // Using displayName as placeholder field
  created_at: HouseholdOrderField.CreatedAt,
};

// Stable reference to avoid unnecessary re-renders
export const DEFAULT_SORT: HouseholdOrder[] = [
  { field: HouseholdOrderField.CreatedAt, direction: OrderDirection.Desc },
];

export function useClientListPageSort(initialOrderBy?: HouseholdOrder[]) {
  return useDataGridSort({
    columnFieldToSortField,
    defaultSort: initialOrderBy ?? DEFAULT_SORT,
  });
}
